module.exports = __webpack_public_path__ + "band_10.576c0b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_10.png
// module id = aJbo
// module chunks = 0